import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=eb27d4fa&scoped=true&"
import script from "./Basics.vue?vue&type=script&lang=js&"
export * from "./Basics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb27d4fa",
  null
  
)

export default component.exports